import React from 'react';
import { Link } from 'react-router-dom';

// Lightweight logo component
// variant='arrow' uses the arrow-only mark; default uses the full wordmark
const Logo = ({ size = 36, variant = 'full' }) => {
  const logoFile = variant === 'arrow' ? 'keyflow_arrow_logo.png' : 'keyflow_logo.png';
  const style = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    textDecoration: 'none',
  };

  return (
    <Link to="/" style={style} aria-label="KeyFlo Home">
      <img
        className="site-logo"
        src={`${process.env.PUBLIC_URL || ''}/${logoFile}`}
        alt="KeyFlo"
        style={{ height: '38px', width: 'auto' }}
      />
    </Link>
  );
};

export default Logo;
